<template>
  <div
    class="menubar"
    :class="(!xd_flag )&&'xd-active'"
    @mouseenter="menubarMouseenter"
    @mouseleave="menubarMouseleave"
    @touchmove.prevent
  >
    <div class="logo flex-column-center ">
      <img
        :src="imgHeaderLogoSrc"
        alt=""
      >
    </div>
    <ul>
      <li
        v-for="menu in menus"
        :key="menu.id"
        @mouseenter="showDropdown(menu)"
        @mouseleave="hideDropdown"
      >
        <a
          :href="menu.link"
          class="line"
          :class="menu.id===index &&'selected'" 
          @click="isTop() "
        >
          <span
            class="title"
          >{{ menu.title }}</span>
        </a>
        <!-- 弹出框 -->
        <div
          v-if="dropdown === menu.id"
          class="dropdown-menu"
        >
          <a
            v-for="subItem in menu.subItems"
            :key="subItem.link"
            :href="subItem.link"
          >
            {{ subItem.title }}
          </a>
        </div>
      </li>
    </ul>
    
    <div
      id="toggleBar"
      class="bar"
    >
      <img
        :src="imgMoreSrc"
        alt=""
        class="nav-logo"
      >
    </div>
  </div>
</template>
<script>
import imgMore from "@/assets/images/more.svg"
import imgMoreBlack from "@/assets/images/more-black.svg"
import imgHeaderLogo from "@/assets/images/header-logo.png"
import imgHeaderLogoBlack from "@/assets/images/header-logo-black.png"

export default {
    name: "HeaderView",
    data () {
        return{
            imgMoreSrc: imgMore,
            imgHeaderLogoSrc: imgHeaderLogo,
            xd_flag: false,
            dropdown: null, // 当前显示的下拉菜单
            menus: [
                {
                    id: 1,
                    title: "トップページ",
                    link: "#/",
                    subItems: [],
                },
                {
                    id: 2,
                    title: "企業情報",
                    link: "#/company-info",
                    subItems: [
                        { title: "代表挨拶", link: "#/company-info#greetings" },
                        { title: "会社概要", link: "#/company-info#overview" },
                        { title: "沿革", link: "#/company-info#history" },
                        { title: "主要取引先", link: "#/company-info#partner" },
                        { title: "国内、海外拠点紹介", link: "#/company-info#base" },
                    ],
                },
                {
                    id: 3,
                    title: "事業内容",
                    link: "#/services",
                    subItems: [
                        { title: "SIサービス", link: "#/services#siservice" },
                        { title: "ソリューション事業", link: "#/services#solution" },
                        { title: "オフショア開発", link: "#/services#offshore" },
                    ],
                },
                {
                    id: 4,
                    title: "日中貿易業務",
                    link: "#/sino-japan-trade",
                    subItems: [
                        { title: "研磨材事業", link: "#/sino-japan-trade" },
                    ],
                },
                {
                    id: 5,
                    title: "パートナー募集",
                    link: "#/partner",
                    subItems: [ ],
                },
                {
                    id: 6,
                    title: "人材募集",
                    link: "#/recruitment",
                    subItems: [ ],
                },
                {
                    id: 7,
                    title: "問い合わせ",
                    link: "#/inquiry",
                    subItems: [ ],
                },
            ],
        }
    },
    computed: {
        index () {
            let path = this.$route.name;
            switch(path) {
                case "Home":
                    return 1;
                case "CompanyInfo":
                    return 2;
                case "Services":
                    return 3;
                case "SinoJapanTrade":
                    return 4;
                case "Partner":
                    return 5;
                case "Recruitment":
                    return 6;
                case "Inquiry":
                    return 7;
                default:
                    return 0;
            }
        },
    },
    mounted () {
        let that = this;

        let toggleBar = document.getElementById("toggleBar");
        let MenubarUl = document.querySelector(".menubar ul");
        let LeftSildeMenubar = document.querySelector(".menubar ul");

        //显示侧滑导航栏
        toggleBar.onclick = function () {
            LeftSildeMenubar.classList.toggle("active");
            document.body.style.overflow = "hidden";
        }

        //隐藏策划导航栏
        MenubarUl.onclick = function () {
            LeftSildeMenubar.classList.remove("active");
            document.body.style.overflow = "scroll";
        }
    
        //吸顶
        window.onscroll = function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop === 0) {
                that.setXdFlag(true)
            }else{
                that.setXdFlag(false)
            }
        }
        
        this.setXdFlag(true)
    },
    methods: {
        showDropdown (menu) {
            if(menu.subItems.length === 0) {
                this.dropdown = null; 
            }else{
                if(document.body.clientWidth > 1060) {
                    this.dropdown = menu.id; // 设置当前悬停的菜单ID
                }
            }
        },
        hideDropdown () {
            this.dropdown = null; 
        },
        menubarMouseenter () {
            this.setXdFlag(false);
        },
        menubarMouseleave () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop === 0) {
                this.setXdFlag(true);
            }
        },
        isTop () {
            setTimeout(() => {
                // alert("isTop")
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop === 0) {
                    this.setXdFlag(true)
                }else{
                    this.setXdFlag(false)
                }
            }, 500);
        },
        setXdFlag (flag) {
            if(flag && this.index === 1) {
                // alert("在顶部")
                // 在顶部
                this.xd_flag = true;
                this.imgMoreSrc = imgMore
                this.imgHeaderLogoSrc = imgHeaderLogo
            }else{
                // alert("不在顶部")
                // 不在顶部
                this.xd_flag = false;
                this.imgMoreSrc = imgMoreBlack
                this.imgHeaderLogoSrc = imgHeaderLogoBlack
            }

        }
    },
}
</script>
<style lang="scss" scoped>

.nav-logo{
  display: none;
  width: 30px;
  margin-top: 15px;
  vertical-align: middle;
  margin-left: 15px;
}
.xd-active{
  opacity: 1 !important;
  // box-shadow: 0 0 6px #0d0d0dab;
  color: #333333 !important;
  background: white;
  transition: all 0.3s ease;
}

.content {
  width: 100%;
  height: 100%;
  text-align: center;
}

.menubar {
  position: fixed;
  width: 100%;
  top: 0;
  height: 60px;
  display: flex;
  flex-direction: row;
  user-select: none;
  z-index: 100;
  color: white;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(0, 0, 0, .05);
}

.menubar .logo {
  width: 60px;
  text-align: center;
  margin-left: 10px;
}

.menubar .logotitle {
  width: 100%;
  line-height: 60px;
  font-size: 24px;
  color: #fff;
}

.menubar ul {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: right;
  text-align: center;
  margin: 0px 40px;
  color: inherit;
  
}

.menubar ul li {
  min-width: 50px;
  list-style: none;
  margin-left: 25px;
  margin-right: 20px;
  transition: all 0.2s ease;
  color: inherit;
}

.menubar ul li a {
  position: relative;
  display: block;
  width: 100%;
  line-height: 60px;
  text-decoration: none;
  color: inherit;
}

.menubar ul li a.line::after {
    position: absolute;
    left: 0;
    // right: 0;
    bottom: 0;
    width: 0;
    height: 3px;
    background: #014099;
    content: "";
    transition: width 0.3s ease-in-out;
}


.menubar ul li a.selected::after {
  width: 100%;
}

.menubar ul li:hover a.line::after {
  width: 100%;
}

.menubar ul li a:hover span{
  color: #0052c4;
}


.menubar ul li a .title {
  position: relative;
  display: block;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  white-space: nowrap;
}

.list {
  margin-left: 5%;
  margin-right: 5%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  justify-content: space-around;
  align-items: center;
}

.list .item {
  flex-basis: 23%;
  margin-top: 22px;
  height: 260px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  transition: .314s;
  cursor: pointer;

}

.list .item:hover{
  transform: scale(1.02);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
}

.list .item .desc {
  width: 90%;
  margin: 16px;
  flex-basis: 80%;
  background-color: #f5f5f5;
}

.list .item .title {
  width: 90%;
  margin: auto 16px;
  margin-bottom: 16px;
  flex-basis: 20%;
  background-color: #f5f5f5;
}

.dropdown-menu {
  position: absolute;
  top: 60px; 
  transform: translateX(-25%); 
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius:5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 1000;
}

.dropdown-menu a {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: #333;
  white-space: nowrap;
  width: auto !important;
  line-height: 20px !important;
}

.dropdown-menu a:hover {
  background-color: #f5f5f5;
}

/* 响应式 */
@media (max-width:1060px) {
  .nav-logo{
    display:block;
  }

  .menubar {
    position: fixed;
    top: 0;
    display: block;
    height: 60px;
    transition: .321s;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
  }

  .menubar .logo {
    position: absolute;
    width: 60px;
    line-height: 60px;
    top: 0;
    margin-left: 10px;
    text-align: left;
    margin-top: 15px;
  }

  .menubar .logotitle {
    width: 100%;
    line-height: 60px;
    font-size: 20px;
    color: #fff;
  }

  .menubar ul {
    width: 0px;
    position: fixed;
    height: 100vh;
    right: -60px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    overflow: hidden;
    transition: .141s;
    z-index: 10;
    box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.1); 
    margin: 0px 0px;
  }

  .menubar ul.active {
    right: 0;
    width: 260px;
    transition: .314s;
  }

  .menubar ul.active::after {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(165, 165, 165, 0.1);
    z-index: -1;
  }

  .menubar ul li {
    width: 100%;
  }

  .menubar ul li a {
    display: flex;
    flex-direction: row;
  }
  
  .menubar ul li a.selected::after {
    width: 0px;
  }

  .menubar ul li:hover a.line::after {
    width: 0px;
  }

  .menubar ul li a .title {
    position: relative;
    display: block;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #333333;
  }

  .menubar .bar {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 60px;
    line-height: 60px;
    cursor: pointer;
  }

  .list .item {
    flex-basis: 45%;
    margin-top: 12px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }
}
</style>
